module.exports = __webpack_public_path__ + "static/contents1-d59886f4f96c2e8d59908409f0072fa4.jpg";